// src/services/companiesService.js
// Cliente frontend para crear y administrar páginas de empresa (Fase 2).
//
// Modelo: un usuario (technician) puede tener su user_profiles personal Y
// además ser owner de N company_profiles. Las RPCs en
// supabase/migrations/20260521010000_company_owner_decoupling.sql validan
// permisos vía owner_id.
import supabase from '../supabase';

// Crear una nueva página de empresa. El caller queda como owner_id.
export async function createCompanyPage({ name, email = null }) {
  if (!name || !name.trim()) return { ok: false, error: 'El nombre es obligatorio' };
  const { data, error } = await supabase.rpc('create_company_page', {
    p_company_name: name.trim(),
    p_email: email,
  });
  if (error) {
    console.error('[companies] createCompanyPage:', error);
    return { ok: false, error: error.message };
  }
  return { ok: true, companyId: data };
}

// Listar empresas que el usuario actual administra (legacy + nuevas)
export async function getMyOwnedCompanies() {
  try {
    const { data, error } = await supabase.rpc('get_my_owned_companies');
    if (error) {
      console.error('[companies] getMyOwnedCompanies:', error);
      return { ok: false, error: error.message, companies: [] };
    }
    return { ok: true, companies: data || [] };
  } catch (err) {
    return { ok: false, error: err.message, companies: [] };
  }
}

// Obtener una empresa por id (lectura pública)
export async function getCompanyById(companyId) {
  if (!companyId) return { ok: false, error: 'invalid_id' };
  const { data, error } = await supabase
    .from('company_profiles')
    .select('*')
    .eq('id', companyId)
    .maybeSingle();
  if (error) return { ok: false, error: error.message };
  return { ok: true, company: data };
}

const companiesService = {
  createCompanyPage,
  getMyOwnedCompanies,
  getCompanyById,
};

export default companiesService;
